import * as React from 'react';
import { cn } from '@frontend/shadcn/lib/utils';

const MetricCard = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => (
    <div ref={ref} className={cn('border rounded-xl border-t-4 p-2', className)} {...props} />
  ),
);
MetricCard.displayName = 'MetricCard';

const MetricCardLabel = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => (
    <div ref={ref} className={cn('text-xs text-gray-600 mb-2', className)} {...props} />
  ),
);
MetricCardLabel.displayName = 'MetricCardLabel';

const MetricCardValue = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => <div ref={ref} className={cn('text-[16px] font-normal', className)} {...props} />,
);
MetricCardValue.displayName = 'MetricCardValue';

const MetricCardBreakdown = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => (
    <div ref={ref} className={cn('text-xs text-gray-500 mt-2 flex items-center justify-start gap-2', className)} {...props} />
  ),
);
MetricCardBreakdown.displayName = 'MetricCardBreakdown';

export { MetricCard, MetricCardLabel, MetricCardValue, MetricCardBreakdown };
